import { AuditActionCode, AuditResourceType } from "@CommonUtils/AuditActionCodes";
import { Pagination, RequiredPaginationQueryParams } from "@CommonTypes/backend/pagination";

export const RouteGetAuditLogs = "/audit-logs";

export type QueryParamsGetAuditLogs = RequiredPaginationQueryParams & {
  /** ISO-8601 start (inclusive). Example: "2026-01-01T00:00:00Z" */
  dateFrom?: string;
  /** ISO-8601 end (inclusive). Example: "2026-02-01T00:00:00Z" */
  dateTo?: string;
  /** Filter by action code. Example: "users:create" */
  actionCode?: AuditActionCode | string;
  /** Filter by resource type. Example: "user" */
  resourceType?: AuditResourceType | string;
  /** Filter by outcome: "success" (2xx) or "failure" (4xx/5xx) */
  status?: "success" | "failure";
  /** Free-text search across http_path and actor_email */
  search?: string;
};

export type ResponseGetAuditLogs = Pagination<AuditLogEntry>;

export interface AuditLogEntry {
  id: number;
  createdAt: string;

  // Who
  userId: number | null;
  merchantId: number | null;
  actorEmail: string | null;
  ipAddress: string | null;
  userAgent: string | null;

  // What
  actionCode: AuditActionCode;
  statusCode: number;

  // Which resource
  resourceType: AuditResourceType | null;
  resourceId: string | null;

  // HTTP context
  httpMethod: string;
  httpPath: string;

  // Extensibility
  metadata: Record<string, unknown> | null;
}
